import { addRolesToTenantUser, createTenantUser } from '@infuse/api/iam/tenant';
import { useGenericCreateUser } from '@infuse/iam/user/mutations';

export const useCreateTenantUser = () =>
  useGenericCreateUser({
    apiFn: createTenantUser,
    roleApiFn: addRolesToTenantUser
  });
